/* eslint-disable react/require-default-props */
/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { BankAccount, UpdateBankAccountDocument } from '@/types/graphql/types'
import { getErrorMessage } from '@/util/getErrorMessage'
import { useMutation } from '@apollo/client'
import { Sx } from '@mantine/core'
import { useForm } from '@mantine/form'
import { showNotification } from '@mantine/notifications'
import { parseInt } from 'lodash'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'

const useUserBankAccount = ({
  bankAccount,
  sx,
  refetch,
}: {
  bankAccount: BankAccount
  sx?: Sx
  refetch?: () => void
}) => {
  const { t } = useTranslation('common')
  const { query } = useRouter()
  const form = useForm({
    initialValues: {
      accountHolderName: bankAccount?.accountHolderName || '-',
      bankName: bankAccount?.bankName || '-',
      iban: bankAccount?.iban || '-',
    },
  })
  const scrollToButton = () => {
    const element = document.getElementById('sendRequest')
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }
  //update bank account mutation
  const [mutate, { loading }] = useMutation(UpdateBankAccountDocument, {
    onCompleted() {
      showNotification({
        title: t('updated'),
        message: t('updatedSuccessfully'),
      })
      scrollToButton()
      if (refetch) refetch()
    },
    onError(error) {
      showNotification({
        title: t('error'),
        message: getErrorMessage(error),
        color: 'red',
        autoClose: false,
      })
    },
  })
  //submit bank account data
  const submit = (values: typeof form.values) => {
    mutate({
      variables: {
        data: {
          data: {
            ...values,
            user: {},
          },
          userId: parseInt(query.id as string),
        },
      },
    })
  }
  return {
    submit,
    loading,
    form,
  }
}

export default useUserBankAccount
